import { clsx } from "clsx";
import React from "react";
import AppFooter from "web/react/components/app-footer/app-footer";
import { Divider } from "web/react/components/divider";
import { FooterProps } from "web/react/components/footer/footer";
import ProductCard from "web/react/components/product-card/react";
import { ProductDetails } from "web/react/components/product-card/react/emo";
import { ProductImage } from "web/react/emo/product-card";
import { ProductCardFactory } from "web/types/examples/product-card";
import { ProductLayoutSerializer, ProductPageAreaSerializer } from "web/types/serializers";
import * as styles from "./out-of-stock-product-page.css";

// TODO BEAM-1120 remove
const product = ProductCardFactory();

// remove me as the page is built
function TempSection({ title, id }: { title: string; id?: string }): React.ReactElement {
    return (
        <div className={styles.tempSectionContainer} id={id}>
            {title}
        </div>
    );
}

function SectionDivider({ isMobileOnly }: { isMobileOnly?: boolean }): React.ReactElement {
    return (
        <div className={clsx({ [styles.hideDesktop]: isMobileOnly })}>
            <Divider />
        </div>
    );
}

export interface OutOfStockProductPageProps {
    productArea: ProductPageAreaSerializer;
    productLayout: ProductLayoutSerializer;
    isOverlay?: boolean;
    parentRef?: React.RefObject<HTMLElement>;
    footerData?: FooterProps;
}

export function OutOfStockProductPage({
    // productArea,
    // productLayout,
    // isOverlay,
    // parentRef,
    footerData,
}: OutOfStockProductPageProps): React.ReactElement {
    return (
        <>
            <div className={styles.pageWrapper}>
                <div className={styles.pageContent}>
                    <div className={styles.heroSection}>
                        <TempSection title={"X retailers checked"} />
                        <TempSection title={"last seen"} />
                        <div className={styles.mainBuyOptionPlusOtherOptionsContainer}>
                            <div style={{ width: "300px" }}>
                                <ProductCard product={product}>
                                    <ProductImage />
                                    <ProductDetails />
                                </ProductCard>
                            </div>
                            <TempSection title={"previously available"} />
                        </div>
                    </div>
                    <SectionDivider />
                    <TempSection title={"pba"} />
                    <TempSection title={"more like this grid"} />
                    <TempSection title={"similar brands to"} />
                    <SectionDivider isMobileOnly />
                    <TempSection title={"full product details"} id="product-details" />
                    <TempSection title={"people also searched for"} />
                    <SectionDivider isMobileOnly />
                    <TempSection title={"recently viewed"} />
                </div>
            </div>
            {footerData && (
                <AppFooter
                    data={footerData.data}
                    helpCentreURLs={footerData.helpCentreURLs}
                    country={footerData.country}
                />
            )}
        </>
    );
}
